export function global(name, object) {
    window.cursus = window.cursus ?? {};
    return window.cursus[name] ?? (window.cursus[name] = object);
}


export function stripTags(html) {
    const el = document.createElement('div');
    el.innerHTML = html;
    return el.innerText;
}

export function plural(value) {
    return value > 1 ? 's' : '';
}


export function clone(object) {
    return structuredClone(object);
}

export function slug(string) {
    return string
        ?.normalize('NFD').replace(/[\u0300-\u036f]/g, "") //remove diacritics
        .toLowerCase()
        .replace(/\s+/g, '-') //spaces to dashes
        .replace(/&/g, '-and-') //ampersand to and
        .replace(/[^\w\-]+/g, '') //remove non-words
        .replace(/\-\-+/g, '-') //collapse multiple dashes
        .replace(/^-+/, '') //trim starting dash
        .replace(/-+$/, '');
}
